const state = {
    currentMessageBoard: null,
    currentMessage: null,
};

const mutations = {
    updateMessageBoard(nextState, messageboard) {
        nextState.currentmessageboard = messageboard;
    },
    updateMessage(nextState, currentMessage) {
        nextState.currentMessage = currentMessage;
    },
};

const actions = {
    setCurrentMessageBoard: (context, messageboard) => context.commit('updateMessageBoard', messageboard),
    removeCurrentMessageBoard: (context) => context.commit('updateMessageBoard', null),
    setCurrentMessage: (context, messageboard) => context.commit('updateMessage', message),
    removeCurrentMessage: (context) => context.commit('updateMessage', null),
};

export default {
    state,
    actions,
    mutations,
};
